import { connect } from 'react-redux'
import { useState, useEffect } from 'react'
import { Button, Form, Input, Modal, Result, Typography, Tooltip, notification } from 'antd'
import { SwapOutlined, LoadingOutlined } from '@ant-design/icons'
import { HelpText, errorMessages } from 'Components'
import {
  getRandomDone
  getRandomErrorTitle
  getRandomInit
} from 'Components/ActionsPage/funnies'
import { getMemberKeys } from 'Services/WeaverUtils'
import { fieldData } from './helpers'
import { pluginStatuses } from 'Services/ActionsPagesUtils'
import { Namespaces } from 'Model'
import WeaverService from 'Services/WeaverService'

{ TextArea } = Input
{ Title } = Typography

TransformAttrToRel = ({ memberKey, memberKeys, nameKeys, type, nodeId, label }) ->

  [visible, setVisible] = useState(false)
  [attrKey, setAttrKey] = useState()
  [feedback, setFeedback] = useState()
  [loading, setLoading] = useState(true)
  [form] = Form.useForm()

  useEffect( ->
    ( ->
      setLoading(true)
      namespaces = _.invert((await Namespaces.load()).map())
      [ns, tail] = label.split(':')
      if namespaces["#{ns}:"]?
        setAttrKey(namespaces["#{ns}:"] + tail)
      else
        setAttrKey(label)
      setLoading(false)
    )()
    undefined
  , [])

  handleIconClick = ->
    if !WeaverService.userCanEdit()
      notification.error({
        style: {whiteSpace: 'pre-wrap'}
        message: transformError.message
        description: transformError.description
        duration: 10
      })
    else
      setVisible(true)

  handleFormData = ->
    fieldNames = fieldData.map(({ fieldName, required }) -> fieldName)
    values = await form.validateFields(fieldNames)
    handleTransform(values)

  handleFeedback = (type, e) ->
    switch type
      when pluginStatuses.INIT
        setFeedback({
          type: type
          title: 'Hold tight!'
          icon: <LoadingOutlined />
          message: getRandomInit()
        })
      when pluginStatuses.DONE
        setFeedback({
          type: type
          title: "Transformation completed successfully."
          message: getRandomDone()
        })
      when pluginStatuses.ERRORED
        setFeedback({
          type: type
          title: getRandomErrorTitle()
          message: e.message
        })
      else
        setFeedback(undefined)

  handleTransform = (data) ->
    { sourceType, sourceAttrKey, targetType, targetAttrKey, nameKey, memberKey } = data
    try
      handleFeedback('init')
      p = await Weaver.Plugin.load('weaver-transform')
      obj = {
        'orderedTransformations': [{
          'relate_nodes_based_on_attr_value':
            [[sourceType, sourceAttrKey, targetType, targetAttrKey, nameKey, memberKey]]
        }]
      }
      op = await p.transformFromJson(obj)
      handleFeedback(pluginStatuses.DONE)
    catch e
      handleFeedback(pluginStatuses.ERRORED, e)

  footerPrimaryBttn = ->
    switch feedback?.type
      when pluginStatuses.INIT
        {
          disabled: true,
          text: 'Please wait'
        }
      when pluginStatuses.DONE
        {
          disabled: true,
          text: 'Transform complete'
        }
      when pluginStatuses.ERRORED
        {
          disabled: false
          fn: -> handleFeedback('reset')
          text: 'Retry'
        }
      else
        {
          disabled: false
          fn: -> handleFormData()
          text: "Transform #{attrKey}"
        }

  footer =
    <>
      <Button
        type="primary"
        disabled={ footerPrimaryBttn().disabled }
        onClick={ footerPrimaryBttn().fn }
      >
        { footerPrimaryBttn().text }
      </Button>
      <Button
        onClick={->
          setVisible(false)
          setFeedback(undefined)
        }>
        Cancel
      </Button>
    </>

  transformForm =
    <Form
      form={form}
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 20 }}
      layout="horizontal"
      initialValues={{
        sourceType: nodeId,
        sourceAttrKey: attrKey,
        targetType: attrKey,
        targetAttrKey: nameKeys[0],
        nameKey: attrKey
        memberKey: memberKey or memberKeys[0]
      }}
    >
    {
      fieldData.map(({ Component, editable, fieldName, helpText, required }, i) ->
        <Form.Item
          key="#{i}-#{fieldName}"
          label={_.startCase(fieldName)}
          name={fieldName}
          tooltip={helpText}
          rules={[ { required: required } ]}
        >
          <Component
            query={new Weaver.Query().hasRelationIn(getMemberKeys())}
            disabled={!editable}
          />
        </Form.Item>
      )
    }
    </Form>

  <>
    <Tooltip
      mouseEnterDelay={1}
      title="Transform #{attrKey}"
      placement="right"
    >
      <SwapOutlined
        style={{color: '#888'} if !WeaverService.userCanEdit()}
        data-testid="transform-attr-to-rel-icon-#{label}"
        onClick={handleIconClick}
      />
    </Tooltip>
    <Modal
      maskClosable={false}
      centered={true}
      width={Math.max(800, window.innerWidth * 0.8)}
      className="transform-att-to-rel-container"
      visible={visible}
      destroyOnClose={true}
      footer={footer}
      onCancel={-> setVisible(false)}
      title={
        <Title level={4} style={{ textAlign: 'center' }}>
          Transform <i>{attrKey}</i> attribute into relation
          <HelpText text="Create relations based on the attribute value of the source node and link them to the targetNode with the same value."/>
        </Title>
      }
    >
      {
        if feedback?
          <Result
            status={feedback.type}
            icon={feedback.icon}
            title={feedback.title}
            subTitle={feedback.message}
          />
        else
          !loading && transformForm || <div />
      }
    </Modal>
  </>

export default connect(({ explore }) ->
  {
    memberKeys: explore.memberKeys
    nameKeys: explore.nameKeys
  }
)(TransformAttrToRel)
